import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import ChevronRight from '@react/react-spectrum/Icon/ChevronRight';

const resolveLinkPath = (childTo, parentTo) => `${parentTo}/${childTo}`;

export function NavItemHeader(props) {
  const { item } = props;
  const { label, Icon, to: headerToPath, children } = item;
  const location = useLocation();

  const [expanded, setExpand] = useState(
    location.pathname.includes(headerToPath)
  );

  const onExpandChange = e => {
    e.preventDefault();
    setExpand(expanded => !expanded);
  };

  return (
    <>
      <li
        className="spectrum-SideNav-item spectrum-SideNav-heading"
        data-testid={`nav-item-header-${label
          .replace(/[^a-zA-Z0-9]/g, '-')
          .toLowerCase()}`}
      >
        <button
          className="spectrum-SideNav-itemLink"
          onClick={onExpandChange}
          data-testid={`nav-item-header-button-${label
            .replace(/[^a-zA-Z0-9]/g, '-')
            .toLowerCase()}`}
        >
          {Icon && (
            <Icon
              size="S"
              data-testid={`nav-item-header-icon-${label
                .replace(/[^a-zA-Z0-9]/g, '-')
                .toLowerCase()}`}
            />
          )}
          <span
            className="navLabel"
            data-testid={`nav-item-header-label-${label
              .replace(/[^a-zA-Z0-9]/g, '-')
              .toLowerCase()}`}
          >
            {label}
          </span>
          <ChevronRight
            className={`navItemHeaderChevron ${expanded && 'chevronExpanded'}`}
            size="S"
            data-testid={`nav-item-header-chevron-${label
              .replace(/[^a-zA-Z0-9]/g, '-')
              .toLowerCase()}`}
          />
        </button>
      </li>
      {expanded && (
        <>
          {children.map((item, index) => {
            const key = `${item.label}-${index}`;

            const { label, Icon, children } = item;

            if (children) {
              return (
                <div
                  key={key}
                  data-testid={`nav-item-header-child-wrapper-${label
                    .replace(/[^a-zA-Z0-9]/g, '-')
                    .toLowerCase()}`}
                >
                  <NavItemHeader
                    item={{
                      ...item,
                      to: resolveLinkPath(item.to, props.item.to)
                    }}
                    data-testid={`nav-item-header-child-${label
                      .replace(/[^a-zA-Z0-9]/g, '-')
                      .toLowerCase()}`}
                  />
                </div>
              );
            }

            return (
              <li
                key={key}
                className="spectrum-SideNav-item"
                data-testid={`nav-item-header-child-item-${label
                  .replace(/[^a-zA-Z0-9]/g, '-')
                  .toLowerCase()}`}
              >
                <NavLink
                  to={resolveLinkPath(item.to, props.item.to)}
                  className={({ isActive }) =>
                    isActive
                      ? 'spectrum-SideNav-itemLink is-selected'
                      : 'spectrum-SideNav-itemLink'
                  }
                  data-testid={`nav-item-header-child-link-${label
                    .replace(/[^a-zA-Z0-9]/g, '-')
                    .toLowerCase()}`}
                >
                  {Icon && (
                    <Icon
                      size="S"
                      data-testid={`nav-item-header-child-icon-${label
                        .replace(/[^a-zA-Z0-9]/g, '-')
                        .toLowerCase()}`}
                    />
                  )}
                  <span
                    className="navLabel"
                    data-testid={`nav-item-header-child-label-${label
                      .replace(/[^a-zA-Z0-9]/g, '-')
                      .toLowerCase()}`}
                  >
                    {label}
                  </span>
                </NavLink>
              </li>
            );
          })}
        </>
      )}
    </>
  );
}
